export function showPopup(popup, entityType, id) {
    return (dispatch) => {
        dispatch({
            type: 'POPUP:SHOW',
            popup,
            entityType,
            id,
        });
    };
}

export function showPopupNew({
    popup,
    entityType,
    id,
    playerName,
    savedListIds,
    singleStep,
    onClosePopup,
    onSuccess,
    onPaymentAttempted,
    redirectTo,
    renewalDate,
    referringSurface,
    gatedFeature,
    prismicTitle,
    referralCode,
    plansOffered,
    showHotelPlannerCard,
}) {
    return (dispatch) => {
        dispatch({
            type: 'POPUP:SHOW',
            popup,
            entityType,
            id,
            playerName,
            savedListIds,
            singleStep,
            onClosePopup,
            onSuccess,
            onPaymentAttempted,
            redirectTo,
            renewalDate,
            referringSurface,
            gatedFeature,
            prismicTitle,
            referralCode,
            plansOffered,
            showHotelPlannerCard,
        });
    };
}

export function closePopup(popup) {
    return (dispatch) => {
        dispatch({
            type: 'POPUP:CLOSE',
            popup,
        });
    };
}
